import { Component } from "@angular/core";

import { ApplicationWizardService } from "../application-wizard.service";
import { HTMLInputEvent, ApplicationImage } from "../../../../models";
import { AbstractWizardStepComponent } from "../../../wizard-dialog/abstract-wizard-step.component";
import { ApplicationPortsComponent } from "../application-ports/application-ports.component";
import { ApplicationWizardSummaryComponent } from "../application-wizard-summary/application-wizard-summary.component";

@Component({
	templateUrl: "./application-image-select.component.html"
})
export class ApplicationImageSelectComponent extends AbstractWizardStepComponent<void> {
	public imageSelect: ApplicationImage;

	constructor(
		private service: ApplicationWizardService
	) {
		super();
		this.imageSelect = {
			name: this.service.applicationState.application.name,
			imageBase64: this.service.applicationState.application.image
		};
	}

	public hasImage(): boolean {
		return !!this.imageSelect.imageBase64;
	}

	public fileOnChange(event: HTMLInputEvent) {
		if (event.target.files) {
			const image: File = event.target.files[0];

			const imageWH = new Image();
			imageWH.onload = (e) => {
				this.resizeImage(imageWH);
			};
			imageWH.src = window.URL.createObjectURL(image);
		}

	}

	public resizeImage(image: HTMLImageElement) {
		const imageSelect: ApplicationImage = { imageBase64: "", name: this.imageSelect.name };
		let dimensions = { width: 0, height: 0 };
		const imageWidth = 160;
		const imageHeight = 60;

		const widthMultiplier = getMultiplier(image.width, imageWidth);
		const newBasedOnWidth = getNewDiminsions(widthMultiplier, image.width, image.height);
		if (newBasedOnWidth.width <= imageWidth && newBasedOnWidth.height <= imageHeight) {
			dimensions = newBasedOnWidth;
		} else {
			const heightMultiplier = getMultiplier(image.height, imageHeight);
			const newBasedOnHeight = getNewDiminsions(heightMultiplier, image.width, image.height);
			dimensions = newBasedOnHeight;
		}

		const canvas = document.createElement("canvas");
		canvas.width = dimensions.width;
		canvas.height = dimensions.height;
		const context = canvas.getContext("2d");
		if (!context) {
			throw new Error("failed to create 2d rendering context for image");
		} else {
			context.drawImage(image, 0, 0, canvas.width, canvas.height);
			imageSelect.imageBase64 = canvas.toDataURL();
			this.imageSelect = imageSelect;
			this.service.applicationState.application.image = imageSelect.imageBase64;
		}
	}

	public useDefaultImage() {
		this.imageSelect.imageBase64 = "";
		this.service.applicationState.application.image = "";
	}

	public get title() {
		return this.service.applicationState.isCreate ?
			"application.wizard.title.create" : "application.wizard.title.update";
	}

	public get description() {
		return "application.wizard.selectImage.description";
	}

	public get nextStep() {
		return ApplicationWizardSummaryComponent;
	}

	public get previousStep() {
		return ApplicationPortsComponent;
	}

	public get isFormValid() {
		return true;
	}

	public performPrevious() {
		this.save();
	}

	public performNext() {
		this.save();
	}

	public get showProgressBar() {
		return false;
	}

	private save() {
		this.service.applicationState.application.image = this.imageSelect.imageBase64;
	}
}

function getMultiplier(value: number, maxValue: number) {
	return maxValue / value;
}

function getNewDiminsions(multiplier: number, width: number, height: number) {
	const localWidth = Math.round(width * multiplier);
	const localHeight = Math.round(height * multiplier);
	return { width: localWidth, height: localHeight };
}
